import { Avatar, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
// import { chatsData } from '../../../../config/data'
import {
  getFormattedDateTime,
  notifyWhenChannelHasUnreadMessages,
  resetSelectedChannelUnreadMsgCount,
} from "../../../../config/utils";
import { useDispatch, useSelector } from "react-redux";
import {
  setNavigateToChannel,
  setSelectedChannelId,
} from "../../../../store/common/chatSlice";
import { getSocketInstance } from "../../../../config/hooks/utility/socket";
import dayjs from "dayjs";
import { getMyChatChannels } from "../../../../store/common/chatSlice/api";

const ChatList = ({ selectedChatCb, hasChats }) => {
  const dispatch = useDispatch();
  const { loggedInUser } = useSelector((state) => state?.auth);
  const { channelsUnreadMsgs, chatChannels, navigateToChannel } = useSelector(
    (state) => state?.chats,
  );

  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);

  const socket = getSocketInstance();

  const getReceipientData = (chatMembers) => {
    if (chatMembers && chatMembers.length) {
      return chatMembers.filter((e) => e.memberId != loggedInUser?.id)[0];
    }
  };

  const getSenderData = (chatMembers) => {
    if (chatMembers && chatMembers.length) {
      return chatMembers.filter((e) => e.memberId == loggedInUser?.id)[0];
    }
  };

  const handleSelectedChat = (chat) => {
    if (chat) {
      const memberData = getReceipientData(chat?.chatMembers);
      if (memberData) {
        const { memberId, user } = memberData;
        const { id: channelId, chatMembers } = chat; //channel id

        //for chat module
        setSelectedChat({
          memberId,
          channelId,
          user,
          chatMembers,
        });
        selectedChatCb({
          memberId,
          channelId,
          user,
          chatMembers,
        });

        if (socket) {
          const otherUserId = chatMembers.filter(
            (e) => e.memberId != loggedInUser?.id,
          )[0]["memberId"];
          socket.emit("message:read", {
            channelId,
            memberId: loggedInUser?.id,
            otherUserId,
          });

          resetSelectedChannelUnreadMsgCount(channelId);
          dispatch(setSelectedChannelId(channelId));
        }
      }
    }
  };

  const getChannelUnreadMsgsCount = (channelId) => {
    if (channelsUnreadMsgs && channelsUnreadMsgs.length) {
      const selectedChannel = channelsUnreadMsgs.filter(
        (e) => e.channelId == channelId,
      );
      if (selectedChannel.length) {
        return selectedChannel[0]?.unreadMessageCount;
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  };

  const getChannelLastUnreadMsg = (channelId) => {
    // debugger
    if (channelsUnreadMsgs && channelsUnreadMsgs.length) {
      const selectedChannel = channelsUnreadMsgs.filter(
        (e) => e.channelId == channelId,
      );
      if (selectedChannel.length) {
        return selectedChannel[0]?.message;
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  };

  const sortChatsByDatetime = (chats) => {
    const tmpChats = JSON.parse(JSON.stringify(chats));
    for (let i = 0; i < tmpChats.length; i++) {
      const channelUpdatedAt = channelsUnreadMsgs.filter(
        (e) => e.channelId == tmpChats[i].id,
      );
      if (channelUpdatedAt.length) {
        tmpChats[i].updatedAt = channelUpdatedAt[0].updatedAt;
      }
    }
    const sorted = tmpChats.sort((a, b) =>
      dayjs(b.updatedAt).diff(dayjs(a.updatedAt)),
    );
    return sorted;
  };

  const getChatReceipientName = (members) => {
    const firstName = getReceipientData(members)?.user?.fullName.split(" ")[0];
    return firstName.length > 5 ? firstName.slice(0, 5) + "..." : firstName;
  };

  useEffect(() => {
    dispatch(getMyChatChannels());
    dispatch(setSelectedChannelId(-1));
  }, []);

  useEffect(() => {
    if (chatChannels && chatChannels.length) {
      setChats(() => [...chatChannels]);
      hasChats(true);
    }
  }, [JSON.stringify(chatChannels)]);

  useEffect(() => {
    const myUnreadMsgsCount = getSenderData(
      selectedChat?.chatMembers,
    )?.unreadMessageCount;
    if (myUnreadMsgsCount) {
      dispatch(getMyChatChannels());
    }
  }, [selectedChat]);

  useEffect(() => {
    let tmpChats = chats;
    if (tmpChats.length) {
      if (channelsUnreadMsgs && channelsUnreadMsgs.length) {
        tmpChats = sortChatsByDatetime(tmpChats);
        setChats(() => [...tmpChats]); //creates new array instance for react to detect change instantly and render

        // resetSelectedChannelUnreadMsgCount(selectedChat?.channelId)
      }
    }
  }, [JSON.stringify(channelsUnreadMsgs)]);

  useEffect(() => {
    //run when change in channel data
    notifyWhenChannelHasUnreadMessages(
      chatChannels,
      channelsUnreadMsgs,
      loggedInUser?.id,
    );
  }, [JSON.stringify(chatChannels), JSON.stringify(channelsUnreadMsgs)]);

  useEffect(() => {
    //when user clicks on new msg notification, auto select its that channel
    if (navigateToChannel && channelsUnreadMsgs && channelsUnreadMsgs.length) {
      const lastReceivedMsg = channelsUnreadMsgs[0];
      if (lastReceivedMsg) {
        const lastReceivedMsgDetails = chatChannels.filter(
          (e) => e.id == lastReceivedMsg?.channelId,
        );
        if (lastReceivedMsgDetails.length) {
          handleSelectedChat(lastReceivedMsgDetails[0]);
        }
      }
      dispatch(setNavigateToChannel(false));
    }
  }, [navigateToChannel]);

  return (
    <Row>
      <Col span={24}>
        {chats && chats.length
          ? chats.map((chat, cIdx) => (
              <div
                key={"chat" + cIdx}
                onClick={() => handleSelectedChat(chat)}
                className={`flex flex-col p-2 cursor-pointer justify-between
                ${selectedChat && selectedChat?.channelId == chat.id && "bg-primary"}
              sm:h-[80px] h-[90px]`}
              >
                <div className="flex items-center mb-2">
                  <div className="w-1/4">
                    <div
                      className={`rounded-full p-[2px] w-full
                    ${selectedChat && selectedChat?.channelId == chat.id ? "border-[#fff] border-2" : "border-[#fab700] border"}
                  `}
                    >
                      <Avatar
                        src={
                          getReceipientData(chat?.chatMembers)?.user
                            ?.imageThumbUrl
                        }
                        className="w-full h-full aspect-square object-cover"
                        size={"small"}
                      >
                        {getReceipientData(chat?.chatMembers)
                          ?.user?.fullName?.charAt(0)
                          ?.toUpperCase()}
                      </Avatar>
                    </div>
                  </div>
                  <div className="flex pl-2 w-3/4">
                    <div className="w-full flex">
                      <div className="flex flex-col w-3/4">
                        <h6
                          className={`heading-6 text-sm font-semibold 
                          ${selectedChat && selectedChat?.channelId == chat.id && "text-white"}`}
                        >
                          {getChatReceipientName(chat?.chatMembers)}
                        </h6>
                        <p
                          className={`text-xs ellipsis ${selectedChat && selectedChat?.channelId == chat.id && "text-white"}`}
                        >
                          {getChannelLastUnreadMsg(chat?.id) !== undefined ? (
                            <span>{getChannelLastUnreadMsg(chat?.id)}</span>
                          ) : getChannelLastUnreadMsg(chat?.id) ===
                            undefined ? (
                            <span>{chat?.lastMessage}</span>
                          ) : (
                            ""
                          )}
                        </p>
                      </div>
                      <div className="flex flex-col items-end w-1/4">
                        <small
                          className={`text-xs pt-1 ${selectedChat && selectedChat?.channelId == chat.id && "text-white"}`}
                        >
                          {getFormattedDateTime(chat?.updatedAt, "HH:mm")}
                        </small>
                        {selectedChat?.channelId != chat?.id ? (
                          getChannelUnreadMsgsCount(chat?.id) !== undefined &&
                          getChannelUnreadMsgsCount(chat?.id) > 0 ? (
                            <div className="flex justify-center items-center mt-1 bg-red-500 rounded-full w-[20px] h-[20px] p-[2px] text-white text-[10px]">
                              {getChannelUnreadMsgsCount(chat?.id)}
                            </div>
                          ) : getChannelUnreadMsgsCount(chat?.id) ===
                              undefined &&
                            getSenderData(chat?.chatMembers)
                              ?.unreadMessageCount ? (
                            <div className="flex justify-center items-center mt-1 bg-red-500 rounded-full w-[20px] h-[20px] p-[2px] text-white text-[10px]">
                              {
                                getSenderData(chat?.chatMembers)
                                  ?.unreadMessageCount
                              }
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {cIdx != chats.length - 1 &&
                selectedChat?.channelId != chat.id ? (
                  <hr className="border-1 border-slate-100" />
                ) : (
                  ""
                )}
              </div>
            ))
          : ""}
      </Col>
    </Row>
  );
};

export default ChatList;
